import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiModule } from '../shared-ui/shared-ui-module';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MenubarModule } from 'primeng/menubar';
import { AlbumComponent } from './album/album.component';
import { FolderComponent } from './folder/folder.component';
import { PhotosComponent } from './photos/photos.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { OrgHeaderComponent } from './org-header/org-header.component';
import { DocCenterComponent } from './doc-center/doc-center.component';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';
import { CarouselModule } from 'primeng/carousel';

@NgModule({
    imports: [
        CommonModule,
        SharedUiModule,

        ButtonModule,
        DialogModule,
        MenubarModule,
        DropdownModule,
        MultiSelectModule,
        TooltipModule,
        CarouselModule,
    ],
    declarations: [
        AlbumComponent,
        FolderComponent,
        PhotosComponent,
        BreadcrumbComponent,
        OrgHeaderComponent,
        DocCenterComponent,
    ],
    exports: [
    ],
    providers: [
    ]
})
export class MainUiModule {}
